import classNames from 'classnames'

import { Loading } from 'app/components/atoms'

import { borderStyles } from './styles'

import ArrowDownIcon from 'public/icons/arrow-down.svg'

import { useTranslation } from 'app/i18n/client'

interface NativeSelectProps {
  name?: string
  isError?: boolean
  loading?: boolean
  disabled?: boolean
  value: any
  options: {
    label: string
    value: any
  }[]
  onSelect: (value: any) => void
  className?: string
  hideDefaultOptions?: boolean
}

// Plain native <select>. NOT inside a <button> or Headless UI Listbox: that
// triggers Listbox.Options' useScrollLock and freezes <html> overflow on iOS
// Safari whenever Listbox state goes Open (TSN-140).
const NativeSelect: React.FunctionComponent<NativeSelectProps> = ({
  name,
  isError,
  loading,
  disabled,
  value,
  options,
  className,
  onSelect,
  hideDefaultOptions,
}) => {
  const { t } = useTranslation()

  return (
    <div className="relative">
      <div
        className={classNames(
          'w-full focus:outline-none py-3.5 px-4 text-base flex justify-between',
          isError ? borderStyles.error : borderStyles.default,
          disabled
            ? 'bg-gray-100'
            : isError
              ? 'bg-[#E74C3C] bg-opacity-15'
              : 'bg-[#FAFAFA]',
          className,
          {
            '!opacity-40': loading || disabled,
          },
        )}
      >
        {loading ? (
          <div className="flex-1 flex items-center justify-center py-3 px-4">
            <Loading className="!text-white" baseClassName="!text-priority" />
          </div>
        ) : (
          <select
            name={name}
            disabled={disabled}
            value={value ?? ''}
            className="w-full block truncate focus:outline-none bg-transparent"
            onChange={(event) =>
              event.target.value && onSelect(event.target.value)
            }
          >
            {!hideDefaultOptions && <option value="">{t('Select one')}</option>}
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        )}
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
          <ArrowDownIcon className="fill-current text-primary" />
        </div>
      </div>
    </div>
  )
}

export default NativeSelect
